module.exports = __webpack_public_path__ + "static/img/tjnk.bd74d37.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/tjnk.png
// module id = oPPd
// module chunks = 0